import React from 'react';
import { useTranslation } from 'react-i18next';
import { ILocation } from '../../../../../../store/services/locationApi/locationTypes';
import { IBatchData } from '../../../../../../store/services/batchApi/batchTypes';
import BatchesBadge from '../BatchesBadge';
import LocalesBadge from '../LocationBadge';
import { ITagStates } from '../TagDetails';

interface IAuthenticatedTagInfoProps {
  location?: ILocation;
  batches?: IBatchData[];
  isAuthenticated: boolean;
  state: ITagStates
}



const AuthenticatedTagInfo = ({
  location,
  batches,
  isAuthenticated,
  state
}: IAuthenticatedTagInfoProps) => {
  const { t } = useTranslation('tag');



  return isAuthenticated ? (
    <>
      <BatchesBadge batches={batches || []} />
      <LocalesBadge local={location || null} />
    </>
  ) : null;
};

export default React.memo(AuthenticatedTagInfo);
